
import { useEffect, useCallback, useLayoutEffect } from 'react'

import {
  Outlet,
  useNavigate
} from "react-router-dom";

import { ApolloClient, InMemoryCache, gql} from '@apollo/client';

import { authProvider } from "../../auth";
import { PATHS } from "../../paths";

import { REFRESH_TOKEN } from '../../constants';
import { BACKEND_URL } from '../../config';
import { REFRESH_MUTATION } from '../../queries/getRefresh';

const client = new ApolloClient({
  uri: BACKEND_URL,
  cache: new InMemoryCache(),
});

// TODO: make a page to explain to a user why they are now on the login page
const PATH_FOR_FAILED_AUTH = `${PATHS.LOGIN}`;

function Layout() {
    let navigate = useNavigate();

    const tryRefresh = useCallback(async () => {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN);

        if (refreshToken) {
          const refreshRequest = await client.mutate({ mutation: REFRESH_MUTATION, variables: { refreshToken } });

          if (refreshRequest.errors) {
              await authProvider.signout();
              navigate(PATH_FOR_FAILED_AUTH, { replace: true });
          }

          if (refreshRequest?.data?.refresh?.success) {
              await authProvider.signin(refreshRequest?.data?.refresh?.token, refreshRequest?.data?.refresh?.refreshToken);
          } else {
              await authProvider.signout();
              navigate(PATH_FOR_FAILED_AUTH, { replace: true });
          }
        } else {
          navigate(PATH_FOR_FAILED_AUTH, { replace: true });
        }
    }, [navigate])


    useEffect(() => {
        const intervalId = setInterval(() => tryRefresh(), 29 * 60 * 1000); // 29 minutes

        return () => clearInterval(intervalId);
    }, [tryRefresh]);

    useLayoutEffect(() => {
        const onVisibilityChange = async () => {
            if (document.visibilityState === 'visible' && document.location.pathname !== '/signup') {
                // Tab reopened - user the refresh token
                await tryRefresh()
            }
        };

        document.addEventListener("visibilitychange", onVisibilityChange);

        return () => document.removeEventListener("visibilitychange", onVisibilityChange);
    }, [tryRefresh]);

  return (
    <div>
      {/* <h1>Joyya</h1>
        */}

      <Outlet />
    </div>
  );
}


export { Layout };
